import { createAction } from '@reduxjs/toolkit';
import { RequestError, User } from 'types';

export const fetch = createAction('user-info-to-modify/fetch', (login: string) => ({
  payload: undefined,
  meta: { login },
}));

export const success = createAction('user-info-to-modify/success', (data?: User) => ({
  payload: data,
}));

export const error = createAction('user-info-to-modify/error', (requestError?: RequestError) => ({
  payload: requestError,
  error: Boolean(requestError),
}));

export default {
  fetch,
  success,
  error,
};
